import PickupTask from 'components/hyperdrive/createTask/PickupTask';
import React from 'react';

export default function PickupTaskDrawer() {
  return (
    <PickupTask/>
  );
}
